module.exports = __webpack_public_path__ + "img/34.7b54987c.jpg";